import React from 'react';
import {Col, Container, Row, Button} from "react-bootstrap";
import {Trans, withTranslation} from "react-i18next";

// React Components
import Header from '../../../components/Header/Header';
import BulletHeader from "../../../components/BulletHeader/BulletHeader";

// Icons
import emoticon from "../../../assets/images/wink.svg";

// CSS Files
import './styles.css';

class Welcome extends React.Component {
   render() {
      const { t } = this.props;

      return (
         <div>
            <Header headerBarTitle={t("registration_page.header")} showHeaderExtras showBackButton/>

            <Container className={"desktop"}>
               <Row>
                  <Col className={"pb-3"} xs={12} sm={12}>
                     <BulletHeader text={t("registration_page.welcome")}/>
                  </Col>
               </Row>
               <Row className={"toplabel mb-5"}>
                  <Col xs={12}>
                     <BulletHeader text={t("registration_page.league_what_is")}/>
                     <p className="padelbox-explanation-text padelbox-explanation-spacing">
                         <Trans i18nKey="registration_page.league_what_is_note" components={{ br: <br /> }} />
                        <span className="emoticon-text-align"><img src={emoticon} alt="wink emoticon"/></span>
                     </p>
                  </Col>
               </Row>
               <Row className={"btn-align-bottom"}>
                  <Container className={"desktop"}>
                     <Col xs={12}>
                        <Button onClick={this.submit} className="btn-primary w-100">{t("registration_page.ok_go")}</Button>
                     </Col>
                  </Container>
               </Row>
            </Container>
         </div>
      );
   }

   submit = () => {
      this.props.onSubmit();
   }
}

export default withTranslation()(Welcome);